import React from 'react';
import ForgotPasswordRoute from './ForgotPasswordRoute';

const AgentForgotPasswordRoute: React.FC = () => {
  return <ForgotPasswordRoute />;
};

export default AgentForgotPasswordRoute;
